<template>
    <div class="area">
        <h2 class="subtitle">Kontaktinformationer</h2>
        <hr>

        <form @submit.prevent="submit">
            <transition name="fade">
                <notification v-if="error" @hide="error = null" type="danger" :hideButton="true">
                    {{error}}
                </notification>

                <notification v-else-if="success" @hide="success = null" type="success" :hideButton="true">
                    {{success}}
                </notification>
            </transition>

            <div class="field">
                <label class="label" for="name">{{$t('global.forms.name')}}</label>

                <div class="control">
                    <input type="text" name="name" id="name" class="input" :placeholder="$t('global.forms.name')" autofocus
                           v-model="name" v-validate="'required'" :data-vv-as="$t('global.forms.name')" >
                </div>

                <p v-if="veeErrors.has('name')" class="help is-danger">{{ veeErrors.first('name') }}</p>
            </div>

            <div class="field">
                <label class="label" for="phoneNumber">{{$t('global.forms.phoneNumber')}}</label>

                <div class="control">
                    <input type="text" name="phoneNumber" id="phoneNumber" class="input" :placeholder="$t('global.forms.phoneNumber')"
                           v-model="phoneNumber" v-validate="'required|numeric|min:8'" :data-vv-as="$t('global.forms.phoneNumber')" >
                </div>

                <p v-if="veeErrors.has('phoneNumber')" class="help is-danger">{{ veeErrors.first('phoneNumber') }}</p>
            </div>

            <div class="field">
                <p class="control">
                    <button type="submit" class="button is-info" :disabled="veeErrors.any()">
                        {{$t('global.actions.update')}}
                    </button>
                </p>
            </div>
        </form>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import StudentService from '@/taskflex/students/services/StudentService';
    import Notification from '@/global/components/Notification';

    export default {
        data() {
            return {
                name: null,
                phoneNumber: null,
                success: null,
                error: null,
            };
        },

        computed: {
            ...mapGetters('auth', [
                'currentUserAccount',
            ]),
        },

        mounted() {
            const { name, phone_number: phoneNumber } = this.currentUserAccount;

            this.name = name;
            this.phoneNumber = phoneNumber;
        },

        methods: {
            togglePassword() {
                this.passwordType = this.passwordType === 'password' ? 'text' : 'password';
            },

            submit() {
                this.$validator.validateAll().then((result) => {
                    if (!result) {
                        return;
                    }

                    const { id } = this.currentUserAccount;

                    const options = {
                        name: this.name,
                        phone_number: this.phoneNumber,
                    };

                    StudentService.update(id, options, () => {
                        this.success = 'Dine kontakt oplysninger er nu ændret.';
                    }, () => {
                        this.error = 'Vi kunne ikke ændre dine oplysninger. Prøv venligst igen.';
                    });
                });
            },
        },

        components: {
            Notification,
        },
    };
</script>



// WEBPACK FOOTER //
// src/taskflex/students/components/account/ContactInformationArea.vue